<template>
    <vCommodityFLowStateComponent :postList="postList" v-if="flag"></vCommodityFLowStateComponent>
</template>
<script>
import vCommodityFLowStateComponent from '../../listComponent/basicdata/commodityFlowState/commodityFlowStateComponent.vue';
export default {
    name: 'commodityFlowStateList',
    components: {
        vCommodityFLowStateComponent
    },
    data() {
        return {
            postList: {
                headerTitle: false,

                searchBtn: true,
                resetBtn: true,
                downFileBtn: true,
                setBtn: true,
                addBtn: true
            },
            flag: false
        };
    },
    mounted() {
        this.flag = false;
        this.$nextTick(() => {
            this.flag = true;
        });
    },
    methods: {}
};
</script>
<style lang="scss" scoped="scoped">
</style>